module.exports = __webpack_public_path__ + "static/adambeyer_3-d6d96c5c961a161623db969579c3fbf5.jpg";